import React from 'react';
import RateTypesForm from './RateTypesForm'; // Correct path

const NewRateTypePage = () => {
    return <RateTypesForm formType="create" currentRateTypeId={null} />;
};

export default NewRateTypePage;